<template>
<!--    <div class="container bodywrap-content">-->
    <el-scrollbar class="container bodywrap-content" style="height: 100%;" :native="false">
        <div style="width: 1220px;margin: 0 auto">
            <h1 class="course-manage-title ml0">{{publicClass.course_name}}</h1>
            <div class="res-container row">
                <div class="res-leftarea">
                    <div class="res-list">
                        <div class="video-box">
                            <video id="videoIns" width="100%" height="100%" :src="videoSrc" autoplay controls></video>
                        </div>
                        <!-- <div class="pub-video-info">
                            <div class="pub-name">课程讲解：{{publicClass.course_name}}</div>
                        </div> -->
                        <div style="color: #333; font-size: 18px; margin: 19px 0 16px 0;">为你推荐</div>
                        <div style="display: grid; grid-template-columns: repeat(4, 1fr); grid-gap: 24px; cursor: pointer;">
                            <div v-for="item in resData" @click="viewPublicClassDetail(item)">
                                <img :src="item.course_cover" style="width: 100%; height: 154px; border-radius: 8px;">
                                <div style="font-size: 17px; color: #22242E; margin: 10px 0;">{{ item.course_name }}</div>
                                <div style="font-size: 13px; color: #313D54;">课程分类：{{ item.course_type }}</div>
                            </div>
                       
                        </div>
                        <div class="pub-course-info">
                            <!-- <div class="c-content-title">课程内容</div> -->
                            <el-tabs v-model="activeName">
                                <el-tab-pane label="课程内容" name="课程内容">          
                                    <div class="c-public-content">
                                        <p>
                                            <span style="font-family: 微软雅黑, sans-serif; font-size: 14px;">{{publicClass.course_desc}}</span>
                                        </p>
                                    </div>
                                </el-tab-pane>
                            </el-tabs>
                  
                        </div>
                    </div>
                </div>
                <!-- <RecommendCourse></RecommendCourse> -->
            </div>
        </div>
<!--    </div>-->
    </el-scrollbar>
</template>

<script>
    import RecommendCourse from 'components/qualityCourse/RecommendCourse';
    export default {
        name: "PublicClassDetail",
        components: {
            RecommendCourse
        },
        data() {
            return {
                publicClassId: Number(this.$route.query.id) || '',
                publicClass: {
                    course_id: '',
                    course_name: '',
                    course_desc: '',
                },
                videoSrc: "",
                activeName: '课程内容',
                resData: []
            }
        },
        created() {
            this.getCourseInfo();
            this.getCourseList();
        },
        watch: {
            '$route'(to, from) {
                this.publicClassId = to.query.id;
                this.getCourseInfo();
            }
        },
        methods: {
            viewPublicClassDetail(item) {
                this.$router.push({
                    path: '/qualityCourse/PublicClassDetail',
                    query: {
                        id: item.course_id
                    }
                })
            },
            getCourseInfo() {
                this.$shttp.axiosGetBy(this.$api.courseContent,{id: this.publicClassId}, (res) => {
                    if (res.code === 200) {
                        this.publicClass = res.data;
                        let tmp = this.$common.filterResource(res.data.course_content, res.data.reslist, res.data.papers ,res.data.projects);
                        this.videoSrc = tmp[0].children[0].children[0].file_preview_path;
                    } else {
                        this.$message({
                            type: 'warning',
                            message: res.msg,
                            duration: 1000,
                            onClose: () => {
                                this.$router.push('/user/login');
                            }
                        });
                    }
                })
            },
            getCourseList() {
                let params = {
                    page: 1,
                    limit: 4,
                    type: 2
                }

                this.$shttp.axiosGetBy(this.$api.courses, params, (res) => {
                    if (res.code === 200) {
                        this.resData = res.list;
                    }
                }, (err) => {
                    console.log(err)
                })
            },
        },
    }
</script>

<style scoped lang="scss">
    .quality-course-container {
        .bodywrap-content {
            /*min-height: 802px;*/
            box-sizing: border-box;
            /*margin: 0 auto;*/
            /*height: calc(100% - 84px) !important;*/
            ::v-deep .el-scrollbar__wrap {
                overflow-x: hidden;
                margin-right: -32px !important;
            }
        }
        .container {
            /*width: 1220px;*/
            padding-right: 15px;
            padding-left: 15px;
            margin-right: auto;
            margin-left: auto;
            .course-manage-title {
                color: #3C3C3C;
                font-size: 32px;
                margin: 40px 0 0;
                width: 1000px;
                font-weight: bold;
            }
            .row {
                display: flex;
                flex-wrap: wrap;
            }
            .res-container {
                display: flex;
                justify-content: start;
                margin-left: 0;
                .res-leftarea {
                    width: 1200px;
                    margin: 0;
                    .res-list {
                        .video-box {
                            margin: 20px 0 0 0;
                            width: 1200px;
                            height: 675px;
                        }
                        .pub-video-info .pub-name {
                            color: #333;
                            font-size: 20px;
                            padding: 15px 0;
                            border-bottom: 1px solid #E0E0E1;
                            margin: 0 5px;
                        }
                        .pub-course-info {
                            margin: 30px 5px 60px 5px;
                            ::v-deep .el-tabs__nav-wrap {
                                padding-left: 30px;
                            }
                            .c-content-title {
                                font-size: 16px;
                                color: #666;
                                margin-bottom: 30px;
                                &::before {
                                    content: '';
                                    display: inline-block;
                                    width: 3px;
                                    height: 16px;
                                    background: #E31D1A;
                                    margin: 0 10px 0 0;
                                    vertical-align: -2px;
                                }
                            }
                            .c-public-content {
                                color: #666666;
                                line-height: 24px;
                                padding: 0 30px;
                                p {
                                    margin-top: 0;
                                    margin-bottom: 1rem;
                                }
                            }
                        }
                    }
                }
            }
        }
    }
</style>
<style>
    .el-tabs__item.is-active {
            color: #333;
            font-size: 16px;
    }
    .el-tabs__active-bar {
        background-color: #006EFF;
    }
</style>